import {
  DELETE_PICTURE_FEEDBACK,
  PictureFeedbackActionTypes,
  UPDATE_PICTURE_FEEDBACK,
} from "./actions";
import { initialPictureFeedbackState, IPictureFeedbackState } from "./types";

export const pictureFeedbackReducer = (
  state: IPictureFeedbackState = initialPictureFeedbackState,
  action: PictureFeedbackActionTypes,
): IPictureFeedbackState => {
  switch (action.type) {
    case UPDATE_PICTURE_FEEDBACK:
      return {
        ...state,
        [action.payload.pictureId]: {
          feedback: action.payload.feedback,
          feedback_id: action.payload.feedback_id,
        },
      };

    case DELETE_PICTURE_FEEDBACK:
      return {
        ...state,
        [action.payload.pictureId]: {
          feedback: undefined,
          feedback_id: undefined,
        },
      };

    default:
      return state;
  }
};
